module.exports = __webpack_public_path__ + "static/media/sdp-logo.a38185bb.webp";